export default "__VITE_ASSET__469c2bb0__"